import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FormControlBase } from '../form-control-base';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-email-typeahead',
  templateUrl: './input-email-typeahead.component.html',
  styleUrls: ['./input-email-typeahead.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputEmailTypeaheadComponent),
      multi: true
    },
  ]
})
export class InputEmailTypeaheadComponent extends FormControlBase<any> implements OnInit {
  @Input() name;
  @Input() isDisabled: boolean;
  @Input() iconClass: 'icon-email';
  @Input() placeholder = '';
  @Input() label: string;
  errors = inputMgsErrs.email;
  states: string[] = [];
  emails: string[] = [
    '@gmail.com',
    '@outlook.com',
    '@yahoo.com',
    '@hotmail.com'
  ];
  _isBlur = true;

  private key = '@';
  private flagSetState = false;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  get isInvalid() {
    if (!this.browserIE && this.control) {
      return this._isBlur && (this.submitted || this.control.touched) && this.control.invalid;
    }
    return false;
  }

  ngOnInit() {
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.browserIE = true;
    }
    this.checkInitialControl();
  }

  inputChange(val) {
    if (val) {
      // check flag
      if (val.indexOf(this.key) === -1) {
        this.flagSetState = false;
        this.states = [];
      }

      // add state
      if (!this.flagSetState && val.indexOf(this.key) !== -1) {
        const name = val.substring(0, val.indexOf(this.key));
        this.flagSetState = true;
        this.emails.forEach(((value) => {
          this.states.push(name + value);
        }));
      }
    }
  }
}
